module.exports = __webpack_public_path__ + "r-v3/img/ico_stopwatch_setting_white.d060155f.svg";